import type { BlogPost } from "./blog";

export const BLOG_CUISINE_PART2: BlogPost[] = [
  {
    "slug": "utinoe-konfi-istoriya-retsept",
    "title": "Утиное конфи: история и рецепт классического блюда",
    "metaTitle": "Утиное конфи — история и рецепт | Паруса на крыше СПб",
    "metaDescription": "Что такое утиное конфи, как его готовят и почему это блюдо стоит попробовать в ресторане. История и техника приготовления.",
    "keywords": "утиное конфи ресторан, утиная ножка конфи петербург, конфи утка что это",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Утиное конфи — одно из самых известных блюд французской кухни. Медленное томление утиной ножки в собственном жиру при низкой температуре — техника, которой несколько веков. Результат — невероятно нежное мясо с хрустящей корочкой.",
    "sections": [
      {
        "heading": "История блюда",
        "body": "Конфи (confit — от французского «сохранять») придумали в Гаскони, на юго-западе Франции, задолго до появления холодильников. Мясо, приготовленное в жиру и залитое им же, могло храниться несколько недель. Утка, гусь, свинина — всё это консервировали методом конфи. Сегодня это не способ хранения, а способ достичь определённой текстуры мяса: сочного внутри и хрустящего снаружи.",
        "list": [
          "Происхождение: Гасконь, Франция, традиционная крестьянская техника",
          "Метод: медленное томление в собственном жиру при 80–90°C",
          "Время: 8–12 часов при низкой температуре",
          "Результат: мясо отходит от кости, текстура — шелковистая"
        ]
      },
      {
        "heading": "Почему конфи вкуснее обычного тушения",
        "body": "Разница между конфи и обычным тушением — в среде и температуре. При тушении в воде или бульоне мясо варится. В жиру при низкой температуре — оно медленно пропитывается собственными соками. Мышечные волокна расслабляются постепенно, не сжимаясь от резкого жара. Итог — мясо остаётся нежным, но держит форму, а финальная обжарка даёт хрустящую золотистую кожу.",
        "highlight": "Хорошее конфи можно узнать по звуку: при нажатии на кожицу слышится хруст. Если кожа мягкая — значит, финальная обжарка не была достаточно горячей."
      },
      {
        "heading": "Утиное конфи в ресторанном меню",
        "body": "В хорошем ресторане утиное конфи — маркер кухонной культуры. Это блюдо требует времени и понимания техники. В меню «Парусов на крыше» (ул. Марата, 5) авторская кухня включает блюда с классическими французскими техниками. Средний чек 1 300 ₽, бизнес-ланч от 590 ₽. Посмотреть актуальное меню — на <a href='/menu' class='underline text-accent'>странице меню</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню ресторана", "href": "/menu" }
  },
  {
    "slug": "burrata-italyanskiy-syr",
    "title": "Буррата: итальянский сыр, который стоит попробовать",
    "metaTitle": "Буррата итальянский сыр — что это и с чем есть | Паруса на крыше",
    "metaDescription": "Что такое буррата, чем отличается от моцареллы, как её едят и где попробовать в Петербурге.",
    "keywords": "буррата что это, буррата ресторан петербург, буррата сыр спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Буррата — итальянский сыр, который снаружи выглядит как обычная моцарелла, но внутри скрывает нежную смесь сливок и моцарельных нитей. Разрезаешь — и из неё вытекает кремовая начинка. Один из самых фотогеничных сыров в мире.",
    "sections": [
      {
        "heading": "Что такое буррата",
        "body": "Буррата появилась в итальянской Апулии в начале XX века. Её придумали, чтобы использовать остатки моцареллы: обрезки (страчателла) смешивали со сливками и помещали внутрь шарика из свежей моцареллы. Название от итальянского burro — масло: намёк на маслянистость сливочной начинки.",
        "list": [
          "Внешняя оболочка: свежая моцарелла",
          "Начинка: страчателла (нити моцареллы) + сливки",
          "Происхождение: Апулия, Италия, начало XX века",
          "Срок хранения: 1–2 дня — свежайший продукт"
        ]
      },
      {
        "heading": "Как правильно есть бурату",
        "body": "Буррату подают комнатной температуры (не из холодильника — холод убивает вкус). Классическое сочетание: томаты черри + руккола + оливковое масло + морская соль + немного бальзамика. Хлеб рядом обязателен — вымакивать сливочную начинку. Вино: лёгкое белое или розовое.",
        "highlight": "Буррата теряет всю прелесть через 24–48 часов. В хорошем ресторане она всегда свежая — это показатель качества логистики."
      },
      {
        "heading": "Где попробовать в Петербурге",
        "body": "Буррата есть в меню многих ресторанов Петербурга с итальянским акцентом. Смотрите актуальное меню «Парусов на крыше» на <a href='/menu' class='underline text-accent'>странице меню</a> — авторская кухня включает классические итальянские техники в авторской интерпретации. Ресторан на ул. Марата, 5, 6 этаж, рейтинг 5,0."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "chto-takoe-konfi-tekhnika",
    "title": "Что такое конфи: техника французской кухни",
    "metaTitle": "Что такое конфи — техника французской кухни | Паруса на крыше",
    "metaDescription": "Объясняем метод конфи в кулинарии: история, техника, применение. Что можно приготовить методом конфи.",
    "keywords": "что такое конфи, конфи техника приготовления, конфи кулинария что это",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Конфи — одна из старейших французских кулинарных техник. Продукт медленно готовится в жиру или масле при температуре значительно ниже точки кипения. Результат — особая текстура и концентрированный вкус.",
    "sections": [
      {
        "heading": "Принцип техники конфи",
        "body": "Ключевое отличие конфи от жарки — температура. Жарка: 160–200°C, быстро, корочка снаружи, возможна сухость. Конфи: 70–90°C, медленно (часы), равномерное прогревание, полное сохранение соков. Продукт буквально томится в жировой среде, которая защищает его от прямого жара и равномерно проводит тепло.",
        "list": [
          "Температура: 70–90°C (не кипение, не жарка)",
          "Среда: жир (утиный, оливковое масло, сливочное масло)",
          "Время: 2–12 часов в зависимости от продукта",
          "Результат: нежность, сочность, насыщенный вкус"
        ]
      },
      {
        "heading": "Что готовят методом конфи",
        "body": "Классика — утка и гусь. Но техника применима к любому белку: свинина, курица, рыба (особенно лосось). Современные шефы делают конфи из овощей (помидоры в масле, чеснок) и даже яичных желтков. Яичный желток конфи при 64°C — полужидкий, шелковистый, с насыщенным вкусом — стал популярным элементом авторских блюд.",
        "highlight": "Помидоры конфи в оливковом масле с чесноком и тимьяном — простейший способ попробовать технику дома. 2–3 часа при 100°C трансформируют обычные томаты в нечто концентрированное и невероятно вкусное."
      },
      {
        "heading": "Конфи в ресторанном меню как маркер",
        "body": "Наличие конфи в меню говорит о том, что кухня работает долгосрочно: продукты готовятся накануне или заранее. Это признак организованной кухни и понимания техники. В «Парусах на крыше» (ул. Марата, 5) авторская кухня предполагает именно такой подход. Смотрите меню на <a href='/menu' class='underline text-accent'>странице ресторана</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню ресторана", "href": "/menu" }
  },
  {
    "slug": "tryufel-v-pitstse-restoran",
    "title": "Трюфель в пицце: зачем и с чем сочетать",
    "metaTitle": "Трюфель в пицце — что это и зачем | Паруса на крыше СПб",
    "metaDescription": "Трюфель в ресторанном меню: виды трюфелей, почему они дорогие, как их сочетать с едой.",
    "keywords": "трюфель пицца ресторан, трюфель блюда ресторан петербург, трюфельное масло ресторан",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Трюфель — самый дорогой гриб в мире. Белый трюфель из Альбы может стоить несколько тысяч евро за килограмм. Его аромат — земляной, мускусный, интенсивный — невозможно описать словами, только попробовать.",
    "sections": [
      {
        "heading": "Виды трюфелей",
        "body": "Белый трюфель (Tuber magnatum): сезон октябрь–декабрь, только Пьемонт и Истрия, запах — самый интенсивный, едят сырым, настрагивая ламелями. Цена — 2 000–5 000 € за кг. Чёрный трюфель Перигора (Tuber melanosporum): сезон декабрь–март, можно термически обрабатывать, ароматнее при нагреве. Летний трюфель (Tuber aestivum): дешевле, менее ароматный, доступен почти всегда. Большинство «трюфельных» блюд в ресторанах средней ценовой категории — с летним трюфелем или трюфельным маслом.",
        "list": [
          "Белый трюфель: самый дорогой, едят сырым, ноябрь–декабрь",
          "Чёрный трюфель Перигора: термически обрабатывается, зима",
          "Летний трюфель: доступный вариант, есть весь год",
          "Трюфельное масло: концентрат аромата, гораздо дешевле"
        ]
      },
      {
        "heading": "Трюфель и пицца: почему это работает",
        "body": "Пицца с трюфелем — современный гастрономический тренд. Тонкое дрожжевое тесто, мягкий сыр (фонтина или моцарелла), яичный желток, и сверху — трюфель или трюфельное масло. Высокая температура духовки (400°C в дровяной печи) раскрывает аромат. Простота теста подчёркивает, а не перебивает трюфельный аромат.",
        "highlight": "Трюфельное масло и настоящий трюфель — разные вещи. Масло создаётся с синтетическим аналогом аромата. Настоящий трюфель в блюде — это ламели, видимые глазом на тарелке."
      }
    ],
    "cta": { "text": "Посмотреть меню ресторана", "href": "/menu" }
  },
  {
    "slug": "neapolitanskaya-pitstsa-otlichie",
    "title": "Неаполитанская пицца: чем отличается от обычной",
    "metaTitle": "Неаполитанская пицца — в чём отличие | Паруса на крыше СПб",
    "metaDescription": "Что такое неаполитанская пицца, почему она особенная, чем отличается от обычной пиццы в ресторане.",
    "keywords": "неаполитанская пицца ресторан, пицца наполи что это, пицца дровяная печь петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Неаполитанская пицца — это официально признанное ЮНЕСКО нематериальное культурное наследие. Её тесто, технология и ингредиенты строго регламентированы. Разберём, чем она принципиально отличается от того, что продаётся в большинстве пиццерий.",
    "sections": [
      {
        "heading": "Три критерия настоящей неаполитанской пиццы",
        "body": "Тесто: долгая ферментация (24–72 часа), только мука, вода, соль, дрожжи. Раскатывается руками (не скалкой), края пышные — «корничоне». Выпечка: дровяная печь, 430–480°C, 60–90 секунд. Ингредиенты: томаты Сан-Марцано, моцарелла фиор ди латте или буффало, свежий базилик, оливковое масло.",
        "list": [
          "Тесто: 24–72 часа ферментации, никакой скалки",
          "Печь: дровяная, 430–480°C, 60–90 секунд",
          "Томаты: только Сан-Марцано — кисло-сладкие, густые",
          "Корничоне: пышный, с «леопардовыми» пятнами"
        ]
      },
      {
        "heading": "Почему «леопардовые» пятна — признак качества",
        "body": "Чёрные обугленные пятна (leopardatura) на корже настоящей неаполитанской пиццы — не брак, а признак правильной температуры и ферментации. При 450°C за 90 секунд тесто не успевает пересохнуть — оно остаётся мягким внутри и хрустящим снаружи. Пятна — следы прямого контакта с раскалённым каменным полом печи.",
        "highlight": "Хорошая неаполитанская пицца не хрустит по всей поверхности. Центр остаётся слегка влажным, корж гибкий. Именно поэтому её принято складывать пополам — «а libro» (как книгу)."
      }
    ],
    "cta": { "text": "Посмотреть меню ресторана", "href": "/menu" }
  },
  {
    "slug": "ikra-blyuda-restoran-vidy",
    "title": "Икра в блюдах ресторана: виды и сочетания",
    "metaTitle": "Икра в ресторане — виды и с чем есть | Паруса на крыше СПб",
    "metaDescription": "Икра в ресторанном меню: красная, чёрная, прочие виды. Как выбрать и с чем сочетать икру.",
    "keywords": "икра ресторан блюда петербург, икра меню ресторан, красная икра черная икра ресторан спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Икра — деликатес с тысячелетней историей. В России это особый продукт с культурным контекстом. В ресторанном меню икра появляется в нескольких форматах: как отдельная закуска, как акцент в блюде, как часть дегустационного сета.",
    "sections": [
      {
        "heading": "Виды икры в меню",
        "body": "Чёрная икра (осетровых рыб): белуга, осётр, севрюга — в порядке убывания размера икринки и цены. Редкость и цена делают её маркером высококлассного ресторана. Красная икра (лосося): горбуши (дешевле), кеты, нерки (дороже). Вкус различается — нерка нежнее и насыщеннее. Икра морских ежей (uni): японская традиция, солёный океанический вкус умами.",
        "list": [
          "Чёрная икра: белуга — самая крупная, осётр — стандарт, севрюга — мелкая",
          "Красная: нерка > кета > горбуша по вкусу и цене",
          "Икра морского ежа: умами, японская традиция в авторской кухне",
          "Фальшивая (лосось-имитация): гранулы, не икра — избегайте"
        ]
      },
      {
        "heading": "Классические сочетания с икрой",
        "body": "Чёрная икра: блины, сметана, вода или водка (не вино — убивает вкус). Красная икра: блины, масло, лёгкое шампанское или брют. Икра морского ежа: суши, паста, ризотто, яичный желток конфи — умами усиливает всё вокруг. Главное правило: икра — акцент, а не основа. Её должно быть ровно столько, чтобы вкус ощущался, но не доминировал.",
        "highlight": "Серебряная ложка для икры — не причуда. Металл окисляется и портит тонкий вкус икры. Правильная подача: перламутровые, рожковые или пластиковые ложечки."
      }
    ],
    "cta": { "text": "Посмотреть меню ресторана", "href": "/menu" }
  },
  {
    "slug": "proshutto-chto-eto-s-chem-edyat",
    "title": "Прошутто: что это такое и с чем едят",
    "metaTitle": "Прошутто — что это и с чем есть | Паруса на крыше СПб",
    "metaDescription": "Что такое прошутто, чем отличается от хамона, как его правильно есть и в каких блюдах используется.",
    "keywords": "прошутто что это, прошутто ресторан петербург, прошутто сочетания блюдо",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Прошутто — итальянская вяленая ветчина из свиного окорока. Слово «прошутто» означает просто «окорок» по-итальянски, но в мировой гастрономии оно стало синонимом деликатеса с тонким нарезом и сложным вкусом.",
    "sections": [
      {
        "heading": "Прошутто крудо и котто",
        "body": "Два главных вида: прошутто ди Парма (крудо — сырое, вяленое): выдерживается 12–36 месяцев в горных условиях Пармы. Вкус — солоноватый, нежный, тающий. Прошутто котто (варёное): менее известное, ближе к обычной ветчине. В ресторанах под «прошутто» обычно подразумевают именно крудо.",
        "list": [
          "Прошутто ди Парма: 12–36 месяцев выдержки, защищённое название",
          "Прошутто ди Сан Даниеле: альтернатива Парме, чуть слаще",
          "Прошутто котто: варёная версия, менее деликатесная",
          "Срез должен быть почти прозрачным — тонкость нарезки важна"
        ]
      },
      {
        "heading": "Чем прошутто отличается от хамона",
        "body": "Хамон — испанский эквивалент. Главное отличие: порода свиней. Хамон иберико делают из иберийской свиньи, которую кормят желудями (bellota) — отсюда ореховый привкус. Прошутто — из обычных свиней, которых кормят сывороткой от пармезана. Вкус прошутто нежнее и молочнее. Хамон — интенсивнее и суше.",
        "highlight": "Классические сочетания прошутто: дыня (сладость + солёность), фиги, инжир, хлебные крисп-крекеры, белое игристое. В горячих блюдах — с пастой, ризотто, пиццей."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "merenга-desert-tekstura",
    "title": "Меренга в десерте: как добиться идеальной текстуры",
    "metaTitle": "Меренга в десерте — секреты текстуры | Паруса на крыше СПб",
    "metaDescription": "Что такое меренга, виды меренги в ресторанных десертах, как её правильно делать и есть.",
    "keywords": "меренга десерт ресторан, меренга что это, виды меренги ресторан",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Меренга — взбитый белок с сахаром, запечённый до хруста или оставленный мягким. Простой состав скрывает бесконечное количество вариаций: от хрустящего безе до кремовой итальянской меренги и пышной японской паппы.",
    "sections": [
      {
        "heading": "Три вида меренги",
        "body": "Французская (холодная): белки взбиваются с обычным сахаром. Самая простая, нежная, нестабильная — подходит для запекания. Итальянская (горячая): горячий сироп 118°C добавляется во взбитые белки. Стабильная, атласная, не оседает. Используется для тортов, кремов, макаронс. Швейцарская (на водяной бане): белки с сахаром нагреваются на водяной бане до 60°C, затем взбиваются. Плотная, блестящая.",
        "list": [
          "Французская: хрустящее безе, безе-торты, просто",
          "Итальянская: крем в тортах, стабильная, профессиональная",
          "Швейцарская: плотная, подходит для украшений",
          "Японская (паппа): самая нежная и воздушная"
        ]
      },
      {
        "heading": "Меренга в ресторанном десерте",
        "body": "В авторских десертах меренга — не просто украшение. Это текстурный элемент: хрустящее безе создаёт контраст с кремовым муссом, кисловатым курдом или мягким мороженым. Правило хорошего десерта: минимум три текстуры — и меренга часто одна из них.",
        "highlight": "Хрустящая меренга на десерте должна оставаться хрустящей. Если она размокла — значит, её приготовили заранее и не хранили правильно (влажность растворяет меренгу). Спрашивайте свежий десерт."
      }
    ],
    "cta": { "text": "Посмотреть меню десертов", "href": "/menu" }
  },
  {
    "slug": "kak-vybrat-desert-v-restorane",
    "title": "Как выбрать десерт в ресторане: советы от шефа",
    "metaTitle": "Как выбрать десерт в ресторане — советы | Паруса на крыше СПб",
    "metaDescription": "Как правильно выбрать десерт в ресторане: какие вопросы задать официанту, на что обратить внимание.",
    "keywords": "как выбрать десерт ресторан, десерт советы ресторан, десерт меню что выбрать",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Десерт — финальный аккорд ужина. Он должен быть лёгким, если вы уже наелись, и достаточно интересным, чтобы запомниться. Расскажем, как выбирать десерт в ресторане осознанно.",
    "sections": [
      {
        "heading": "Правила выбора десерта",
        "body": "Спросите официанта, какие десерты самые популярные — это честная рекомендация от тех, кто видит реакцию гостей ежедневно. Обращайте внимание на «сезонные» и «авторские» позиции — они часто лучше стандартных. Если вы уже сыты — выбирайте лёгкие: сорбе, мусс, паннакотта вместо чизкейка или шоколадного торта. Не бойтесь спросить о размере порции.",
        "list": [
          "Спрашивайте рекомендации официанта — он видит реакции гостей",
          "Сезонные позиции обычно лучше стандартных",
          "Для наевшихся: сорбе, мусс, фрукты — не чизкейк",
          "Хорошее тирамису — показатель кухонной культуры"
        ]
      },
      {
        "heading": "Тирамису как тест кухни",
        "body": "Тирамису — универсальный тест для ресторана. Его делают почти везде, но хорошим он получается редко. Идеальное: савоярди, пропитанные крепким кофе (не переув) и качественным алкоголем (марсала или амаретто), крем из маскарпоне с яичными желтками, какао-пудра сверху. Если тирамису вкусный — кухня умеет работать с техникой.",
        "highlight": "В «Парусах на крыше» десерты — авторские. Это значит: не из полуфабриката, а из свежих ингредиентов. Спросите официанта о десерте дня — в хорошем ресторане он всегда есть."
      }
    ],
    "cta": { "text": "Посмотреть меню десертов", "href": "/menu" }
  },
  {
    "slug": "tsezar-s-krevetkami-istoriya",
    "title": "Цезарь с тигровыми креветками: история и вариации",
    "metaTitle": "Цезарь с тигровыми креветками — история | Паруса на крыше СПб",
    "metaDescription": "История салата Цезарь, классический рецепт и лучшие вариации с морепродуктами в ресторане.",
    "keywords": "цезарь с креветками ресторан, салат цезарь история, цезарь морепродукты ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Салат «Цезарь» — один из самых популярных в мире. Его придумал не итальянец и не американец, а мексиканский ресторатор Цезарь Кардини в Тихуане в 1924 году. С тех пор он стал международным стандартом и бесконечным объектом вариаций.",
    "sections": [
      {
        "heading": "Оригинальный рецепт",
        "body": "Кардини делал Цезарь прямо у стола: листья романо, гренки из хлеба, натёртый пармезан, соус из яичного желтка, лимонного сока, вустерского соуса, чеснока и оливкового масла. Всё перемешивалось вилками — так листья оставались целыми. Никаких анчоусов в оригинале — они появились в более поздних интерпретациях.",
        "list": [
          "Романо (не айсберг!) — главный листовой элемент",
          "Гренки: домашние, из бриоши или белого хлеба",
          "Соус: желток + лимон + вустер + чеснок + оливковое масло",
          "Пармезан: стружкой, не тёртый порошком"
        ]
      },
      {
        "heading": "Цезарь с тигровыми креветками",
        "body": "Добавление морепродуктов — популярная вариация. Тигровые креветки жарятся или готовятся на гриле с чесноком и лимоном, укладываются поверх классического Цезаря. Морской вкус сочетается с умами соуса. Это уже не «оригинальный» Цезарь, но это вкусно. В «Парусах на крыше» (ул. Марата, 5) авторские вариации классических блюд — часть меню. Рейтинг 5,0.",
        "highlight": "Лучший Цезарь — тот, где вы слышите каждый ингредиент отдельно. Когда всё вкусы смешались в одно — это признак слишком раннего заправления или плохого баланса."
      }
    ],
    "cta": { "text": "Посмотреть меню", "href": "/menu" }
  },
  {
    "slug": "ryba-slivochnyy-sous-tekhnika",
    "title": "Рыба в сливочном соусе: секреты приготовления",
    "metaTitle": "Рыба в сливочном соусе — техника приготовления | Паруса на крыше",
    "metaDescription": "Как готовят рыбу в сливочном соусе в ресторане: технология, выбор рыбы, сочетания.",
    "keywords": "рыба сливочный соус ресторан, рыбные блюда петербург ресторан, рыба с соусом ресторан спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Рыба в сливочном соусе — классика французской и северной кухни. Нежность рыбы в сочетании с кремовым соусом — это балансирование вкусов, которое требует точного расчёта.",
    "sections": [
      {
        "heading": "Какая рыба подходит для сливочного соуса",
        "body": "Нежные белые рыбы: треска, палтус, судак, морской окунь — лучший выбор. Их мягкое мясо не конкурирует со сливочным соусом, а дополняет его. Лосось: тоже хорошо, но жирность лосося плюс жирность соуса — нужен баланс кислоты (лимон, каперсы). Жирная скумбрия или сельдь: не подходят — сливочный соус будет ощущаться тяжело.",
        "list": [
          "Лучший выбор: треска, палтус, судак, морской окунь",
          "Лосось: работает с кислым балансом (лимон, каперсы)",
          "Избегать: жирная рыба + сливочный соус = перегруженность",
          "Важно: рыба должна быть свежей, не замороженной"
        ]
      },
      {
        "heading": "Технология правильного соуса",
        "body": "Классический сливочный соус для рыбы: белое вино + лук-шалот → выпаривание → сливки → масло (монтирование). Монтирование маслом (beurre blanc) — когда холодное масло вбивается в горячую основу и создаёт эмульсию — даёт соусу шелковистость. В «Парусах» (ул. Марата, 5) рыбные блюда — часть авторского меню. Рейтинг 5,0, бизнес-ланч от 590 ₽.",
        "highlight": "Хороший сливочный соус не должен быть «мучным» — загущать муку не нужно, эмульсия масла достаточно. Мучной привкус — признак дешёвой технологии."
      }
    ],
    "cta": { "text": "Посмотреть меню рыбных блюд", "href": "/menu" }
  },
  {
    "slug": "biznes-lanch-restoran-peterburg-idei",
    "title": "Бизнес-ланч в ресторане Петербурга: что нужно знать",
    "metaTitle": "Бизнес-ланч в ресторане Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Бизнес-ланч в ресторане Санкт-Петербурга: что обычно включает, цены, лучшие варианты в центре.",
    "keywords": "бизнес-ланч ресторан петербург, бизнес ланч центр спб, деловой обед ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Бизнес-ланч — самый практичный формат ресторанного обеда. Он появился как ответ на нехватку времени у офисных работников: полноценный обед, фиксированная цена, быстрая подача. В Петербурге это устойчивый формат с 11–16 часов по будням.",
    "sections": [
      {
        "heading": "Что обычно включает бизнес-ланч",
        "body": "Стандартный состав: первое блюдо (суп), горячее (мясо или рыба + гарнир), хлеб, напиток (чай, кофе или сок). Премиальные бизнес-ланчи добавляют: закуску или салат, десерт, выбор из нескольких позиций каждого блюда. Цена: от 350 ₽ (столовая/кафе) до 900–1 100 ₽ (ресторан с кухней). Лучшее соотношение цены и уровня: 500–700 ₽.",
        "list": [
          "Базовый: суп + горячее + хлеб + напиток",
          "Расширенный: добавляется закуска и/или десерт",
          "Время: обычно 12:00–16:00, будни",
          "Скорость подачи: 15–25 минут — стандарт"
        ]
      },
      {
        "heading": "Бизнес-ланч в «Парусах» за 590 ₽",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) предлагает бизнес-ланч от 590 ₽ в будние дни. За эту цену — полноценный обед с видом на Петербург с 6-го этажа. Панорама Казанского собора и крыши центра создают атмосферу, которой нет ни в одной столовой. Рейтинг 5,0, 2 606 отзывов.",
        "highlight": "590 ₽ за обед с панорамой центра Петербурга — аномалия в хорошем смысле. В других ресторанах с похожим видом средний чек за ланч — 900–1 400 ₽."
      },
      {
        "heading": "Как выбрать лучший бизнес-ланч",
        "body": "Критерии: свежесть (меню меняется ежедневно?), скорость (важно если обед 45 минут), качество кухни (не «разогретые заготовки»), атмосфера (важно если идёте с клиентом или коллегами). Подробнее о <a href='/blog/menu-biznes-lanch-peterburg-sostav' class='underline text-accent'>составе бизнес-ланча</a>."
      }
    ],
    "cta": { "text": "Забронировать бизнес-ланч", "href": "/" }
  },
  {
    "slug": "obyed-do-600-rubley-restoran-peterburg",
    "title": "Обед до 600 рублей в ресторане Петербурга",
    "metaTitle": "Обед до 600 рублей в ресторане Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Где пообедать до 600 рублей в ресторане Санкт-Петербурга: бизнес-ланч, обзор мест в центре.",
    "keywords": "обед 600 рублей ресторан петербург, бизнес ланч 600 спб, дешёвый обед ресторан центр петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Полноценный обед в хорошем ресторане центра Петербурга за 600 рублей — не миф, а реальность в формате бизнес-ланча. Разберём варианты.",
    "sections": [
      {
        "heading": "Что реально получить за 600 рублей",
        "body": "В будни (12:00–16:00) большинство ресторанов среднего уровня предлагают бизнес-ланч: суп + горячее + напиток. За 550–700 ₽ это вполне реально в центре Петербурга. Ключевое — не спутать с кафетерием или столовой: некоторые рестораны ради лояльности удерживают цену ланча на уровне 500–650 ₽, сохраняя качество кухни.",
        "list": [
          "500–650 ₽: реальный диапазон хорошего бизнес-ланча в центре",
          "Что включает: суп + горячее + хлеб + напиток",
          "Экономия vs столовая: ресторан даёт атмосферу и сервис",
          "Будни: ланчи только по рабочим дням"
        ]
      },
      {
        "heading": "«Паруса» — 590 ₽ за ланч с видом на город",
        "body": "Бизнес-ланч в «Парусах на крыше» стоит от 590 ₽. Полноценный обед. Вид на Казанский собор с 6-го этажа. Авторская кухня. Телефон: +7 (812) 991-10-90. Это не скидка — это стандартная цена будних обедов. Адрес: ул. Марата, 5, Olympic Plaza. Читайте о <a href='/blog/lanch-panoramnom-restorane-spb' class='underline text-accent'>ланче в панорамном ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать обед", "href": "/" }
  },
  {
    "slug": "biznes-lanch-s-pervym-blyudom-spb",
    "title": "Бизнес-ланч с первым блюдом в СПб: где найти",
    "metaTitle": "Бизнес-ланч с первым блюдом СПб 2026 | Паруса на крыше",
    "metaDescription": "Где пообедать с супом в бизнес-ланче в Санкт-Петербурге: рестораны с полноценным обедом в центре.",
    "keywords": "бизнес-ланч с супом спб, бизнес ланч первое блюдо петербург, обед с супом ресторан центр спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Суп в бизнес-ланче — маркер полноценного обеда. Не все рестораны включают первое в стандартный ланч. Расскажем, как найти настоящий «обед с первым» в центре Петербурга.",
    "sections": [
      {
        "heading": "Почему суп важен в ланче",
        "body": "Суп — это не просто блюдо, это разогрев желудка перед горячим, источник жидкости и источник насыщения при небольшой калорийности. Полноценный бизнес-ланч с супом даёт больше сытости при тех же деньгах. Кроме того, суп показывает качество кухни: хороший бульон — признак настоящей готовки, а не разогрева полуфабрикатов.",
        "list": [
          "Суп = бульон ручной работы в хорошем ресторане",
          "Сытость дольше, чем без первого",
          "Маркер полноценной кухни vs разогрев пакетов",
          "Лучшие варианты: супы-пюре, борщ, уха, классические бульоны"
        ]
      },
      {
        "heading": "Ланч в «Парусах»",
        "body": "Бизнес-ланч в «Парусах» (ул. Марата, 5, 6 этаж) — полноценный обед с несколькими переменами, в том числе горячим блюдом. Актуальный состав уточняйте по телефону +7 (812) 991-10-90. Вид на Петербург в комплекте. Читайте о <a href='/blog/menu-biznes-lanch-peterburg-sostav' class='underline text-accent'>составе меню бизнес-ланча</a>."
      }
    ],
    "cta": { "text": "Забронировать бизнес-ланч", "href": "/" }
  },
  {
    "slug": "gde-poobedat-obedenny-pereryv-tsentr-spb",
    "title": "Где пообедать в обеденный перерыв в центре СПб",
    "metaTitle": "Где пообедать в обеденный перерыв центр СПб 2026 | Паруса",
    "metaDescription": "Лучшие места для обеда в обеденный перерыв в центре Санкт-Петербурга: быстро, вкусно, недорого.",
    "keywords": "где пообедать обеденный перерыв центр спб, обед за час центр петербург, быстрый обед ресторан спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "У вас час на обед в центре Петербурга. Куда пойти, чтобы поесть быстро, вкусно и не потратить лишнего? Разбираем стратегию.",
    "sections": [
      {
        "heading": "Стратегия обеда за час",
        "body": "Час = 60 минут. Дорога туда-обратно: 10–15 минут. Ожидание и заказ: 5–10 минут. Еда: 20–25 минут. У вас фактически 20–25 минут на сам обед. Выбирайте рестораны: с подтверждённой быстрой подачей в ланч (бизнес-ланч специально создан для скорости), в пешей доступности от работы, с возможностью предзаказа.",
        "list": [
          "Выбирайте рестораны, специализирующиеся на бизнес-ланче",
          "Бизнес-ланч подаётся за 10–15 минут, обычное меню — 20–30",
          "Предзаказ по телефону экономит время ожидания",
          "Не выбирайте а-ля-карт в ланч — это занимает время"
        ]
      },
      {
        "heading": "«Паруса» и быстрый ланч",
        "body": "Бизнес-ланч в «Парусах» (ул. Марата, 5) специально организован для быстрого обслуживания: фиксированное меню ускоряет подачу. От 590 ₽. Если вы работаете в центре — 15 минут ходьбы стоят того, чтобы пообедать с видом на Петербург. Телефон: +7 (812) 991-10-90. Читайте о <a href='/blog/lanch-panoramnom-restorane-spb' class='underline text-accent'>ланче в панорамном ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать бизнес-ланч", "href": "/" }
  },
  {
    "slug": "zavtrak-s-vidom-na-peterburg-restoran",
    "title": "Завтрак с видом на Петербург в ресторане",
    "metaTitle": "Завтрак с видом на Петербург ресторан 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с завтраком с видом на Санкт-Петербург: где позавтракать с панорамой города.",
    "keywords": "завтрак вид петербург ресторан, завтрак с панорамой спб, где позавтракать с видом петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Завтрак с видом на Петербург — это когда ваше утро начинается с кофе и панорамы куполов. Редкий формат, но именно он задаёт тон всему дню. Расскажем, где это возможно.",
    "sections": [
      {
        "heading": "Почему завтрак с видом — особенный",
        "body": "Утренний Петербург — другой. Туман над крышами рассеивается, первые лучи освещают купола, улицы ещё тихие. Завтрак с этой картиной — почти медитация. Для туристов это способ начать насыщенный день с правильного настроения. Для жителей — редкий повод выйти из дома пораньше.",
        "list": [
          "Утренний свет в Петербурге — золотистый и мягкий",
          "До 10:00 нет туристических толп — тишина и покой",
          "Завтрак с видом — хороший старт для дня прогулок",
          "Для туристов: лучше, чем завтрак в отеле"
        ]
      },
      {
        "heading": "Завтрак в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) — один из немногих петербургских ресторанов с полноценными завтраками и панорамным видом. Время работы и меню завтраков уточняйте по телефону +7 (812) 991-10-90. Вид на Казанский собор, купола и крыши центра. Рейтинг 5,0.",
        "highlight": "Воскресный завтрак в панорамном ресторане — одно из лучших петербургских удовольствий. Медленное утро, хороший кофе, вид на просыпающийся город."
      }
    ],
    "cta": { "text": "Забронировать завтрак", "href": "/" }
  },
  {
    "slug": "zavtrak-dlya-dvoyh-restoran-peterburg",
    "title": "Завтрак для двоих в ресторане Петербурга: идеи",
    "metaTitle": "Завтрак для двоих ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Где позавтракать для двоих в ресторане Санкт-Петербурга: романтический завтрак, вид на город, атмосфера.",
    "keywords": "завтрак для двоих ресторан петербург, романтический завтрак спб, завтрак вдвоём ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Завтрак для двоих в ресторане — романтичный и нестандартный формат. Пока все спят, вы двое с кофе и видом на просыпающийся Петербург — это история, которую стоит пережить.",
    "sections": [
      {
        "heading": "Когда завтрак вдвоём — это особое событие",
        "body": "Годовщина. Первое утро в новом городе. Воскресенье, когда хочется сделать что-то непривычное. Завтрак как альтернатива ужину — иногда это свежее решение. Разница: утром оба отдохнувшие, нет вечерней усталости, можно спланировать день вместе. Ресторан утром тихий — никакой суеты, лучший сервис.",
        "list": [
          "Годовщины и особые даты: нестандартный выбор, запоминается",
          "Первое утро в Петербурге: начать день с панорамы",
          "Воскресный ленивый завтрак: никуда не спешить",
          "Утром в ресторане тихо и спокойно — лучший сервис"
        ]
      },
      {
        "heading": "Что заказать на двоих",
        "body": "Идеальный завтрак для двоих: два кофе (капучино / американо / specialty), одно блюдо яичное (омлет, бенедикт, скрэмбл), одно сладкое (блины, вафли, выпечка), свежий сок или смузи. Не заказывайте слишком много — завтрак должен быть лёгким, чтобы хватило сил на день. В «Парусах» (ул. Марата, 5) меню завтраков формируется с учётом этих принципов. Рейтинг 5,0.",
        "highlight": "Просите столик у окна при бронировании. Вид на утренний Петербург — лучшее украшение завтрака для двоих."
      }
    ],
    "cta": { "text": "Забронировать завтрак", "href": "/" }
  },
  {
    "slug": "kak-vybrat-vino-k-rybnym-blyudam",
    "title": "Как выбрать вино к рыбным блюдам: советы",
    "metaTitle": "Как выбрать вино к рыбным блюдам | Паруса на крыше СПб",
    "metaDescription": "Советы по выбору вина к рыбным блюдам в ресторане: какое белое вино, как избежать ошибок.",
    "keywords": "вино к рыбе советы, вино рыбные блюда ресторан, какое вино к рыбе",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "«Красное к мясу, белое к рыбе» — это упрощение. Но за ним стоит реальная логика. Разберём, как выбирать вино к рыбным блюдам грамотно — и когда правила можно нарушать.",
    "sections": [
      {
        "heading": "Логика паринга вина и рыбы",
        "body": "Рыба — деликатный белок. Большинство красных вин с их танинами создают металлический привкус в сочетании с рыбой. Белые вина — кислотные, лёгкие — поддерживают, а не перебивают рыбный вкус. Базовое правило: чем нежнее рыба, тем легче должно быть вино. Форель и сибас — лёгкое совиньон блан или пино гри. Жирный лосось — хватит более богатого шардоне или даже лёгкого пино нуар.",
        "list": [
          "Нежная белая рыба (треска, камбала): совиньон блан, мюскаде",
          "Сибас, дорада: верментино, пино гри",
          "Лосось: шардоне без дуба или лёгкий пино нуар",
          "Жирная рыба (скумбрия): зинфандель — исключение из правила"
        ]
      },
      {
        "heading": "Когда красное вино к рыбе работает",
        "body": "Лёгкий пино нуар из Бургундии к жирному лососю. Барбера или Дольчетто к сардинам или анчоусам. Розовое провансальское — универсальный вариант для большинства рыбных блюд: и не белое, и не красное, и прекрасно сочетается.",
        "highlight": "Розовое вино — часто лучший выбор для рыбного ужина, когда за столом часть гостей предпочитает красное. Это компромисс, который работает."
      },
      {
        "heading": "Вино в «Парусах»",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5) предлагает широкую винную карту — официант поможет с выбором под конкретное блюдо. Читайте наш материал о <a href='/blog/vino-restoran-spb-rekomendatsii' class='underline text-accent'>вине в ресторане СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин с вином", "href": "/" }
  },
  {
    "slug": "vino-k-myasu-kak-ne-oshibitsya",
    "title": "Вино к мясу: как не ошибиться с выбором",
    "metaTitle": "Вино к мясу — как выбрать правильно | Паруса на крыше СПб",
    "metaDescription": "Какое вино подходит к разным видам мяса: стейк, свинина, баранина, утка. Советы по подбору.",
    "keywords": "вино к мясу советы, вино стейк ресторан, красное вино мясо петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "«Красное к мясу» — правило, которое работает в 80% случаев. Но в оставшихся 20% скрываются самые интересные сочетания. Разберём логику паринга вина и мясных блюд.",
    "sections": [
      {
        "heading": "Красное вино и мясо: почему это работает",
        "body": "Красные вина содержат танины — природные полифенолы с вяжущей текстурой. В сочетании с жирным мясом танины «срезают» жирность и освежают вкус. Жир смягчает грубость танинов. Взаимный баланс — вот механизм. Поэтому молодое, мощное красное (каберне совиньон, сира) идёт к стейку с жирной мраморной корочкой, а нежное мясо (телятина) требует более лёгкого вина.",
        "list": [
          "Стейк рибай (мраморный): каберне совиньон, мальбек",
          "Телятина: пино нуар, сангиовезе",
          "Баранина: сира, гренаш, темпранильо",
          "Свинина: пино нуар или даже белое (рислинг)"
        ]
      },
      {
        "heading": "Мясо на хоспере и вино",
        "body": "Мясо с хоспера (угольного гриля) имеет дымный, карамелизированный вкус. К нему подходят вина с определённой фруктовостью и «дымными» нотками: австралийский шираз, аргентинский мальбек, испанский темпранильо. В «Парусах» (ул. Марата, 5) мясо готовится именно на хоспере. Сомелье или официант подберёт подходящее вино из карты.",
        "highlight": "Спросите официанта: «Какое вино из карты лучше всего идёт к стейку с хоспера?». Хороший официант ответит без секунды колебания."
      }
    ],
    "cta": { "text": "Забронировать ужин со стейком", "href": "/menu" }
  },
  {
    "slug": "chto-takoe-paring-vina-i-edy",
    "title": "Что такое паринг вина и еды в ресторане",
    "metaTitle": "Паринг вина и еды в ресторане — что это | Паруса на крыше",
    "metaDescription": "Что такое паринг еды и вина: принципы гастрономического сочетания, как это работает в ресторане.",
    "keywords": "паринг вина и еды что это, фудпейринг ресторан, вино и еда сочетание принципы",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Паринг (food pairing) — осознанный подбор вина к блюду для взаимного усиления вкусов. Это не строгое правило, а принцип: правильное сочетание делает и вино, и еду лучше, чем каждый по отдельности.",
    "sections": [
      {
        "heading": "Два главных принципа паринга",
        "body": "Контраст: кисловатое вино к жирному блюду освежает, сладкое к острому смягчает. Дополнение: вино с фруктовыми нотками к блюду с фруктовым соусом усиливает общий аккорд. Третий принцип — региональный: вина и блюда из одного региона почти всегда идут вместе (итальянское санджовезе и паста болоньезе).",
        "list": [
          "Контраст: жир + кислота, острое + сладость",
          "Дополнение: схожие вкусовые нотки усиливают друг друга",
          "Региональный принцип: вино и еда из одного места сочетаются",
          "Текстуры: лёгкое вино к лёгкому блюду, мощное к мощному"
        ]
      },
      {
        "heading": "Дегустационный паринг в ресторане",
        "body": "Топ-рестораны предлагают дегустационный сет с парингом: шеф создаёт 5–7 блюд, сомелье подбирает к каждому своё вино. Это образовательный и гастрономический опыт одновременно. В «Парусах» (ул. Марата, 5) можно попросить рекомендации по парингу к любому блюду. Рейтинг 5,0, живая музыка, вид на Петербург. Читайте о <a href='/blog/vino-restoran-spb-rekomendatsii' class='underline text-accent'>винной карте ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин", "href": "/" }
  },
  {
    "slug": "igristoe-vino-dlya-prazdnika",
    "title": "Игристое вино для праздника: как выбрать правильно",
    "metaTitle": "Игристое вино для праздника — как выбрать | Паруса на крыше",
    "metaDescription": "Как выбрать игристое вино для праздника: шампанское, просекко, кава — в чём разница и что подходит.",
    "keywords": "игристое вино для праздника, шампанское просекко кава разница, игристое вино выбрать",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "На любом торжестве открывают игристое — это универсальный язык праздника. Но «шампанское» — это не любое игристое. Разберём разницу и поможем выбрать правильное вино для вашего события.",
    "sections": [
      {
        "heading": "Шампанское, просекко, кава: в чём разница",
        "body": "Шампанское (Champagne): только из Шампани, Франция. Классический метод — вторичное брожение в бутылке. Сложные нотки хлеба, дрожжей, цитруса. Цена — от 3 000 ₽ до бесконечности. Просекко (Prosecco): Италия (Венето). Метод Шарма — резервуар. Фруктовее, легче, слаще. Цена — от 800 ₽. Кава (Cava): Испания, классический метод. Похожа на шампанское, но дешевле и с особым испанским характером.",
        "list": [
          "Шампанское: сложность, хлебные нотки, высокая цена",
          "Просекко: фруктовость, лёгкость, доступная цена",
          "Кава: между шампанским и просекко по стилю и цене",
          "Российское игристое: есть достойные варианты классического метода"
        ]
      },
      {
        "heading": "Что выбрать для какого повода",
        "body": "День рождения, корпоратив на 50+ человек: просекко — оптимально по цене и вкусу. Свадьба или юбилей важного человека: кава или шампанское — уровень подчёркивает значимость. Романтический ужин: бокал шампанского — правильный жест. В «Парусах на крыше» (ул. Марата, 5) широкая карта игристых вин — разных стилей и ценовых диапазонов.",
        "highlight": "Хорошее просекко за 1 500–2 000 ₽ в ресторане доставит не меньше удовольствия, чем посредственное шампанское за 4 000 ₽. Выбирайте по вкусу, а не по стране происхождения."
      }
    ],
    "cta": { "text": "Забронировать торжество с игристым", "href": "/banket" }
  },
  {
    "slug": "avtorskie-kokteyli-restorany-spb",
    "title": "Авторские коктейли в ресторанах СПб: тренды 2026",
    "metaTitle": "Авторские коктейли в ресторанах СПб 2026 | Паруса на крыше",
    "metaDescription": "Авторские коктейли в ресторанах Санкт-Петербурга: тренды 2026, что пробовать, как выбрать.",
    "keywords": "авторские коктейли рестораны спб, коктейли ресторан петербург 2026, бар ресторан коктейли спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Авторский коктейль — это когда бармен думает как шеф-повар: сезонные ингредиенты, баланс вкусов, текстура, подача. В 2026 году петербургская барная сцена развивается активно.",
    "sections": [
      {
        "heading": "Тренды авторских коктейлей 2026",
        "body": "Низкоалкогольные и безалкогольные коктейли (mocktails): рост спроса среди тех, кто следит за здоровьем. Локальные ингредиенты: ягоды Карелии, травы Ленобласти, квас как база. Ферментированные компоненты: чайный гриб (комбуча), кефир, кисломолочные продукты в коктейлях — нестандартно и интересно. Коктейли с горячим: тёплые коктейли на основе травяных сборов для зимы.",
        "list": [
          "Mocktails: безалкогольные на основе крафтовых сиропов",
          "Локальные ингредиенты: карельские ягоды, северные травы",
          "Ферментация: комбуча, кефир как нестандартная база",
          "Тёплые коктейли: актуально в петербургском климате"
        ]
      },
      {
        "heading": "Авторские коктейли в «Парусах»",
        "body": "Барная карта «Парусов» (ул. Марата, 5) включает авторские позиции. Коктейли создаются с учётом меню — некоторые специально предназначены для паринга с определёнными блюдами. Безалкогольные опции присутствуют. Уточняйте актуальное меню при бронировании. Рейтинг 5,0, «Хорошее место 2026»."
      }
    ],
    "cta": { "text": "Забронировать стол с коктейлями", "href": "/" }
  },
  {
    "slug": "chto-takoe-somele-zachem-nuzhen",
    "title": "Что такое сомелье и зачем он нужен в ресторане",
    "metaTitle": "Что такое сомелье в ресторане | Паруса на крыше СПб",
    "metaDescription": "Кто такой сомелье, что он делает в ресторане и как пользоваться его помощью при выборе вина.",
    "keywords": "сомелье что это, кто такой сомелье ресторан, помощь с выбором вина ресторан",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Сомелье — специалист по вину в ресторане. Его задача — помочь гостю выбрать вино, которое идеально дополнит блюдо и не превысит бюджет. Многие стесняются к нему обращаться — напрасно.",
    "sections": [
      {
        "heading": "Что делает сомелье",
        "body": "Формирует и поддерживает винную карту ресторана. Обучает персонал. Помогает гостям с выбором. Иногда — проводит дегустации и ужины с парингом. В хорошем ресторане сомелье — это союзник, а не снобствующий эксперт. Его главная задача — чтобы вы остались довольны, а не чтобы вы потратили максимум денег.",
        "list": [
          "Помогает выбрать вино под блюдо и бюджет",
          "Не давит — только рекомендует",
          "Может подобрать по стилю, если вы описываете предпочтения",
          "В хорошем ресторане это бесплатная услуга"
        ]
      },
      {
        "heading": "Как правильно общаться с сомелье",
        "body": "Скажите: бюджет («не дороже 3 000 за бутылку»), вкусовые предпочтения («люблю фруктовое, не люблю кислое»), повод («это свадебный ужин»), блюдо («у нас морепродукты и стейк»). Этого достаточно для точного выбора. В «Парусах на крыше» (ул. Марата, 5) персонал готов помочь с выбором вина — спрашивайте без стеснения. Рейтинг 5,0. Читайте о <a href='/blog/vino-restoran-spb-rekomendatsii' class='underline text-accent'>вине в ресторанах СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин с вином", "href": "/" }
  },
  {
    "slug": "shampanskoe-ili-prosekko-raznitsa",
    "title": "Шампанское или просекко: в чём разница",
    "metaTitle": "Шампанское vs просекко — в чём разница | Паруса на крыше СПб",
    "metaDescription": "Чем шампанское отличается от просекко: вкус, цена, производство. Что выбрать для праздника.",
    "keywords": "шампанское или просекко разница, просекко шампанское что лучше, игристое вино ресторан выбрать",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "«Давай закажем шампанского» — говорим мы, и заказываем просекко. Это не ошибка — просто важно понимать разницу, чтобы сделать правильный выбор.",
    "sections": [
      {
        "heading": "Ключевые отличия",
        "body": "Шампанское: только Франция, Шампань, традиционный метод (вторичное брожение в бутылке). Выдержка на осадке — от 15 месяцев. Пузырьки мелкие. Вкус: дрожжевые нотки, тосты, орехи, цитрус. Просекко: Италия, Венето и Фриули. Метод Шарма (резервуар). Нет выдержки на осадке. Пузырьки крупнее. Вкус: персик, яблоко, груша — свежий и фруктовый.",
        "list": [
          "Шампанское: выдержка, сложность, дрожжевые нотки",
          "Просекко: свежесть, фруктовость, доступная цена",
          "Пузырьки: у шампанского мельче и дольше держатся",
          "Цена: просекко обычно в 2–4 раза дешевле"
        ]
      },
      {
        "heading": "Что выбрать для вашего случая",
        "body": "Для торжественного момента: шампанское — если бюджет позволяет. Для лёгкого аперитива, девичника, корпоратива на 30+ человек: просекко — оптимально. В «Парусах» (ул. Марата, 5) есть оба варианта — официант посоветует под повод и бюджет."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "degustatsionnyy-set-restoran-peterburg",
    "title": "Дегустационный сет в ресторане Петербурга",
    "metaTitle": "Дегустационный сет ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Что такое дегустационный сет в ресторане: как устроен, сколько стоит, зачем заказывать.",
    "keywords": "дегустационный сет ресторан петербург, дегустационное меню спб, тастинг меню ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Дегустационный сет (tasting menu) — это путешествие по кухне ресторана. Вместо одного блюда вы получаете 5–10 маленьких перемен, каждая из которых — высказывание шефа. Особый формат для тех, кто хочет понять кухню ресторана в полном объёме.",
    "sections": [
      {
        "heading": "Как устроен дегустационный сет",
        "body": "Обычная структура: амюз-буш (приветственный укус от шефа), холодные закуски (2–3 перемены), суп или переходное блюдо, главное блюдо из рыбы, главное блюдо из мяса, предесерт (пале), десерт, миньярдисы (мелкие угощения). Каждая перемена маленькая — 2–4 укуса. Весь сет: 2–4 часа. Запастись временем обязательно.",
        "list": [
          "5–10 перемен по 2–4 укуса каждая",
          "С опциональным парингом вин",
          "Время: 2–4 часа неспешного ужина",
          "Обычно нужно бронировать заранее — не блюда из общего меню"
        ]
      },
      {
        "heading": "Паринг вин к дегустационному сету",
        "body": "Лучшее, что можно сделать с дегустационным сетом — добавить паринг вин. Сомелье подбирает бокал к каждой перемене. Это дороже (обычно +50–100% к стоимости еды), но превращает ужин в полноценный гастрономический опыт. В «Парусах на крыше» (ул. Марата, 5) авторское меню позволяет организовать дегустацию — уточняйте при бронировании. Рейтинг 5,0.",
        "highlight": "Дегустационный сет — не для тех, кто торопится. Это вечер, посвящённый кухне. Приходите отдохнувшими и без жёстких временных ограничений."
      }
    ],
    "cta": { "text": "Узнать о дегустационных сетах", "href": "/menu" }
  },
  {
    "slug": "bezalkogolnye-kokteyli-trend-2026",
    "title": "Безалкогольные коктейли в ресторане: тренд 2026",
    "metaTitle": "Безалкогольные коктейли ресторан тренд 2026 | Паруса на крыше",
    "metaDescription": "Безалкогольные коктейли (mocktails) в ресторанах 2026: тренд, лучшие варианты, чем хороши.",
    "keywords": "безалкогольные коктейли ресторан, мокктейли 2026, безалкогольные напитки ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Безалкогольные коктейли (mocktails) — один из главных трендов ресторанного рынка 2025–2026. Растёт число гостей, которые не пьют алкоголь или ограничивают его потребление — и они хотят такой же вкус и эстетику, как у алкогольных напитков.",
    "sections": [
      {
        "heading": "Почему мокктейли — это серьёзно",
        "body": "Мокктейль — не просто «сок с лимоном». Хороший мокктейль создаётся с той же сложностью, что и коктейль: ферментированные базы (комбуча, кефир, квас), крафтовые сиропы и горечи (биттерс без алкоголя), свежевыжатые соки сложных смесей, ароматные дымы и пены для подачи. Это полноценный гастрономический объект.",
        "list": [
          "Комбуча как база: кислинка, сложность, пробиотики",
          "Крафтовые сиропы: лаванда, чай матча, чёрная смородина",
          "Безалкогольные биттерс: горечь без алкоголя",
          "Дымы и пены: тот же wow-эффект подачи"
        ]
      },
      {
        "heading": "В «Парусах на крыше»",
        "body": "Барная карта «Парусов» (ул. Марата, 5) включает безалкогольные опции — как в виде мокктейлей, так и авторских безалкогольных напитков. Гости, не употребляющие алкоголь, могут выбрать напиток, не уступающий алкогольным по визуальному и вкусовому впечатлению. Рейтинг 5,0, «Хорошее место 2026»."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "chaynaya-karta-restoran-kak-vybrat",
    "title": "Чайная карта в ресторане: как выбрать чай",
    "metaTitle": "Чайная карта в ресторане — как выбрать | Паруса на крыше СПб",
    "metaDescription": "Как выбрать чай в ресторане: виды чаёв, чайная карта, что заказать под блюдо.",
    "keywords": "чайная карта ресторан, как выбрать чай ресторан, чай в ресторане виды",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Хорошая чайная карта в ресторане — признак внимания к деталям. Как выбрать чай под блюдо, время суток и настроение — разберём.",
    "sections": [
      {
        "heading": "Основные виды чаёв в ресторанной карте",
        "body": "Зелёный чай (японский сенча, гён-мяча): лёгкий, свежий, хорошо после рыбы и морепродуктов. Улун (китайский полуферментированный): средней насыщенности, ореховые нотки, универсален. Чёрный (ассамский, цейлонский, дарджилинг): насыщенный, хорошо к мясным блюдам и сладкому. Травяные и фруктовые: без кофеина, хорошо вечером или вместо десерта. Пуэр: выдержанный, землистый, очень насыщенный.",
        "list": [
          "Зелёный: к рыбе, лёгким блюдам, утром",
          "Улун: универсален, к обеду",
          "Чёрный: к мясу, сырам, десертам",
          "Травяные: вечером, без кофеина",
          "Пуэр: для ценителей, после плотного ужина"
        ]
      },
      {
        "heading": "Чай к десерту",
        "body": "Классическое сочетание: шоколадный десерт + дарджилинг или пуэр. Фруктовый десерт + зелёный чай или фруктовый травяной. Миндальный торт + жасминовый зелёный. В «Парусах» (ул. Марата, 5) чайное меню включает разные категории — спрашивайте рекомендации к выбранному десерту. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "kalyannaya-karta-restoran-sostav",
    "title": "Кальянная карта в ресторане: что входит и сколько стоит",
    "metaTitle": "Кальянная карта ресторан — состав и цены | Паруса на крыше",
    "metaDescription": "Что такое кальянная карта в ресторане: виды табака, цены, как выбрать кальян для мероприятия.",
    "keywords": "кальянная карта ресторан, кальян ресторан что выбрать, кальян мероприятие ресторан",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Кальян в ресторане — дополнительная услуга, которая часто становится частью вечеринки или корпоратива. Разберём, из чего состоит кальянная карта и как выбрать подходящий вариант.",
    "sections": [
      {
        "heading": "Как устроена кальянная карта",
        "body": "Стандартная структура: один кальян (сессия 45–90 минут) — базовая позиция. Выбор табачной смеси: классические (одинарные вкусы) vs авторские (смеси от кальянщика). Дополнения: замена колбы (фрукт, чай), особый мундштук, угли конкретного типа. Цена за кальян в ресторанах Петербурга: 900–2 500 ₽ в зависимости от уровня заведения и смеси.",
        "list": [
          "Базовая сессия: 45–90 минут, один вкус",
          "Авторские смеси: микс от кальянщика",
          "Фруктовая колба: апельсин, ананас, яблоко — вместо стекла",
          "Цена: 900–2 500 ₽ в зависимости от ресторана"
        ]
      },
      {
        "heading": "Кальян и мероприятие в ресторане",
        "body": "Кальян хорошо вписывается в корпоратив, девичник или дружескую вечеринку — как финальный аккорд вечера после ужина. В «Парусах» (ул. Марата, 5) кальянная услуга доступна. Уточняйте наличие и актуальные условия при бронировании: +7 (812) 991-10-90. Рейтинг 5,0, «Хорошее место 2026»."
      }
    ],
    "cta": { "text": "Узнать о кальяне в ресторане", "href": "/" }
  },
  {
    "slug": "gde-pokurt-kalyan-restoran-peterburg",
    "title": "Где покурить кальян в ресторане в Петербурге",
    "metaTitle": "Где покурить кальян в ресторане Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с кальяном в Санкт-Петербурге: где можно покурить кальян в ресторане, условия и цены.",
    "keywords": "кальян ресторан петербург, где покурить кальян в ресторане спб, кальян ресторан центр петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Кальян в ресторане в Петербурге — опция, которую предлагают несколько заведений в центре. Расскажем, как найти и что ожидать.",
    "sections": [
      {
        "heading": "Кальян в ресторане vs кальянная",
        "body": "Разница существенная. Кальянная специализируется только на кальяне: широкий выбор табаков, опытные кальянщики, специфическая атмосфера. Ресторан с кальяном: основной фокус — кухня, кальян как дополнительная опция. Для тех, кто хочет покурить кальян во время ужина — ресторан удобнее. Для тех, кто хочет только кальян без еды — специализированная кальянная.",
        "list": [
          "Ресторан с кальяном: удобно совмещать еду и кальян",
          "Кальянная: более широкий выбор, лучшие мастера",
          "Цена в ресторане: обычно выше за опцию",
          "Атмосфера: ресторан культурнее, кальянная — расслабленнее"
        ]
      },
      {
        "heading": "Кальян в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) предлагают кальян как дополнительную услугу. Сочетание: ужин с видом на Петербург + кальян на завершение — популярный формат для корпоративных и дружеских вечеринок. Уточняйте условия при бронировании: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать вечер с кальяном", "href": "/" }
  },
  {
    "slug": "lokal-produkty-severo-zapad-bluda",
    "title": "Локальные продукты Северо-Запада: что едят в Петербурге",
    "metaTitle": "Локальные продукты Северо-Запада в ресторанах | Паруса на крыше",
    "metaDescription": "Какие локальные продукты используют лучшие рестораны Петербурга: рыба, молочка, ягоды из Северо-Запада.",
    "keywords": "локальные продукты северо-запад ресторан, местные продукты ресторан петербург, северо-западная кухня рестораны",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Северо-Запад России богат локальными продуктами: карельская рыба, псковская молочка, ленинградские фермерские хозяйства. Рестораны, работающие с местным продуктом, предлагают настоящий вкус региона.",
    "sections": [
      {
        "heading": "Лучшие продукты Северо-Запада",
        "body": "Рыба: лосось и форель из Карелии, корюшка (сезон апрель–май, петербургский деликатес), салака из Финского залива. Молочные продукты: псковская и ленинградская молочка — сыры, творог, сметана. Ягоды: карельская брусника, черника, морошка. Грибы: белые, лисички — из лесов Ленобласти. Мясо: ягнята, фермерские свиньи из хозяйств Ленинградской области.",
        "list": [
          "Корюшка: петербургский символ, апрель–май",
          "Карельская форель и лосось: свежие круглый год",
          "Морошка: редкая северная ягода, деликатес",
          "Псковские сыры: растущий рынок фермерской молочки"
        ]
      },
      {
        "heading": "Корюшка — рыба, которую нельзя пропустить",
        "body": "Корюшка — маленькая рыба с запахом свежего огурца. Это петербургская весенняя традиция: апрель–май, когда корюшка заходит на нерест в Неву. В это время вся Петроградка пахнет жареной корюшкой. В «Парусах» (ул. Марата, 5) корюшка появляется в меню в сезон. Это обязательная позиция для знакомства с петербургской кухней.",
        "highlight": "Запах жареной корюшки — это запах петербургской весны. Если вы в городе в апреле–мае и не попробовали корюшку — вы пропустили часть города."
      }
    ],
    "cta": { "text": "Посмотреть сезонное меню", "href": "/menu" }
  },
  {
    "slug": "luchshiy-biznes-lanch-nevskiy-spb",
    "title": "Бизнес-ланч у Невского проспекта в СПб: топ мест",
    "metaTitle": "Бизнес-ланч у Невского проспекта СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны с бизнес-ланчем рядом с Невским проспектом в Санкт-Петербурге.",
    "keywords": "бизнес ланч у невского проспекта, рестораны ланч невский спб, обед у невского проспекта петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Невский проспект — деловая и туристическая артерия Петербурга. Бизнес-ланч здесь — насущная потребность тысяч офисных работников и гостей города.",
    "sections": [
      {
        "heading": "Где искать хороший ланч у Невского",
        "body": "Правило: лучшие ланчи — не прямо на Невском (там цены туристические), а на параллельных улицах. Марата, Рубинштейна, Гороховая, Литейный — в 5–10 минутах пешком. Разница в цене: 20–40% ниже, качество — выше или сопоставимо.",
        "list": [
          "Улица Марата: 10 минут от Невского, лучший ресторанный квартал",
          "Рубинштейна: барно-ресторанная зона, есть ланчи",
          "Гороховая: тихие рестораны для деловых встреч",
          "Литейный: офисная публика, хорошие ланчи"
        ]
      },
      {
        "heading": "«Паруса» в 10 минутах от Невского",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) находится в 10 минутах пешком от Невского проспекта. Бизнес-ланч от 590 ₽, вид на панораму города, рейтинг 5,0. Если у вас встреча с клиентом — это значительно лучше любого заведения прямо на Невском. Читайте о <a href='/blog/restorany-nevskiy-prospekt-spb' class='underline text-accent'>ресторанах на Невском</a>."
      }
    ],
    "cta": { "text": "Забронировать бизнес-ланч", "href": "/" }
  },
  {
    "slug": "biznes-lanch-s-desertem-peterburg",
    "title": "Бизнес-ланч с десертом в Петербурге: где найти",
    "metaTitle": "Бизнес-ланч с десертом Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с бизнес-ланчем с десертом в Санкт-Петербурге: полный обед с завершением.",
    "keywords": "бизнес ланч с десертом петербург, обед с десертом ресторан спб, ланч десерт центр петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Бизнес-ланч с десертом — полноценный обед, который завершается на сладкой ноте. Это признак расширенного формата, где ресторан думает об ощущениях гостя.",
    "sections": [
      {
        "heading": "Что даёт десерт в ланче",
        "body": "Психологически: ощущение полноты и завершённости — сладкое в конце сигнализирует мозгу «обед закончен». Практически: небольшой десерт (мини-тирамису, мусс, сорбе) добавляет 100–200 ₽ к стоимости ланча и значительно повышает удовлетворение от обеда. В деловой встрече: дольше за столом — больше времени для разговора.",
        "list": [
          "Психологическое завершение обеда: важно для ощущения сытости",
          "Дополнительное время за столом — хорошо для деловых встреч",
          "Десерт в ланче: обычно мини-версия, не полноценная порция",
          "Разница в цене: +100–250 ₽ за расширенный ланч"
        ]
      },
      {
        "heading": "Ланч в «Парусах»",
        "body": "В «Парусах» (ул. Марата, 5) уточняйте актуальный состав бизнес-ланча — он обновляется регулярно. Телефон: +7 (812) 591-10-90. Вид на Петербург с 6-го этажа делает даже скромный обеденный перерыв незабываемым. Читайте об <a href='/blog/uzhin-dlya-dvoyh-chto-zakazat' class='underline text-accent'>ужине для двоих</a>."
      }
    ],
    "cta": { "text": "Забронировать ланч", "href": "/" }
  },
  {
    "slug": "voskresniy-zavtrak-restoran-peterburg",
    "title": "Воскресный завтрак в ресторане Петербурга: идеи",
    "metaTitle": "Воскресный завтрак ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Воскресный завтрак в ресторане Санкт-Петербурга: где позавтракать неспешно в выходной день.",
    "keywords": "воскресный завтрак ресторан петербург, завтрак выходной день спб, бранч ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Воскресный завтрак в ресторане — это ритуал. Медленное утро, хороший кофе, никуда не надо спешить. Для петербуржцев это уже сложившаяся традиция. Разберём, что искать.",
    "sections": [
      {
        "heading": "Форматы воскресного завтрака",
        "body": "Классический бранч (brunch = breakfast + lunch): 10:00–14:00. Обычно включает яичные блюда, выпечку, соки, кофе, иногда лёгкий алкоголь (мимоза, бокал просекко). Лёгкий завтрак: только кофе и несколько позиций. Полноценное воскресное меню: первое, горячее — как ранний обед. Зависит от того, насколько «ленивым» будет воскресенье.",
        "list": [
          "Бранч: 10:00–14:00, яйца + выпечка + кофе + лёгкий алкоголь",
          "Лёгкий завтрак: быстрее, компактнее",
          "Воскресное меню: почти как ранний обед",
          "С видом на город: особое настроение выходного дня"
        ]
      },
      {
        "heading": "Воскресный завтрак в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) предлагают завтраки в выходные. Уточняйте время начала и состав меню: +7 (812) 991-10-90. Панорамный вид с видом на просыпающийся Петербург — лучший старт выходного дня. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать воскресный завтрак", "href": "/" }
  },
  {
    "slug": "vino-k-syru-klassicheskie-sochetaniya",
    "title": "Вино к сыру: классические сочетания в ресторане",
    "metaTitle": "Вино к сыру — классические сочетания | Паруса на крыше СПб",
    "metaDescription": "Как сочетать вино с сыром: классические пары для ресторана и домашнего стола.",
    "keywords": "вино к сыру сочетания, вино сыр ресторан, какое вино к сыру",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Вино и сыр — одна из самых гармоничных пар в гастрономии. Оба продукта созданы ферментацией, оба имеют сложные, многослойные вкусы. Правильное сочетание усиливает оба.",
    "sections": [
      {
        "heading": "Классические пары",
        "body": "Пармезан + бароло (Италия): мощь к мощи, оба зрелые. Бри, камамбер + шампанское: газ освежает жирность, элегантность к элегантности. Рокфор (голубой сыр) + сотерн или портвейн: сладость вина компенсирует солёность и остроту сыра. Козий сыр + совиньон блан из Луары: регионально-логичная пара. Чеддер + кабerne или амонтильядо (херес).",
        "list": [
          "Мягкие (бри, камамбер): шампанское, пино нуар",
          "Твёрдые (пармезан, чеддер): барроло, каберне",
          "Голубые (рокфор, горгондзола): сотерн, портвейн, токай",
          "Козий (шевр): совиньон блан, мюскаде"
        ]
      },
      {
        "heading": "Сырная тарелка в ресторане",
        "body": "Хорошая сырная тарелка — это 4–5 разных сыров, от мягкого к твёрдому, с дополнениями (мёд, орехи, виноград, чатни). К ней подбирается одно-два вина, способных охватить весь спектр. В «Парусах» (ул. Марата, 5) уточняйте наличие сырной тарелки и рекомендации по вину. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать ужин", "href": "/" }
  },
  {
    "slug": "chaynyy-tserimonial-restoran-spb",
    "title": "Чайная церемония в ресторане СПб: что это такое",
    "metaTitle": "Чайная церемония в ресторане СПб 2026 | Паруса на крыше",
    "metaDescription": "Чайная церемония в ресторане Санкт-Петербурга: форматы, виды чаёв, как это организовать.",
    "keywords": "чайная церемония ресторан спб, чайная церемония петербург, чай ресторан церемония спб",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Чайная церемония в ресторане — нестандартное завершение ужина или отдельное культурное событие. Расскажем, что это такое и где организовать в Петербурге.",
    "sections": [
      {
        "heading": "Форматы чайных церемоний",
        "body": "Китайская гунфу-ча: классическая церемония с использованием маленьких чайников гайвань, поэтапным завариванием и дегустацией 5–8 заварок одного чая. Японская: матча, венчик, точность движений. Авторские (ресторанные): мастер демонстрирует свойства 3–4 чаёв, объясняет вкусы и происхождение. Для ресторанных мероприятий — авторский или гунфу-ча наиболее логичны.",
        "list": [
          "Гунфу-ча: многократное заваривание одного чая",
          "Матча японская: ритуал, философия, точность",
          "Авторская ресторанная: доступнее, образовательно",
          "Длительность: 30–90 минут"
        ]
      },
      {
        "heading": "Чайная церемония как часть корпоратива",
        "body": "Нестандартный вариант для корпоративного ужина: вместо алкоголя или параллельно с ним — организовать чайную церемонию. Хорошо работает для аудитории, которая интересуется оздоровлением, азиатской культурой или просто хочет нестандартного опыта. В «Парусах» (ул. Марата, 5) возможна организация чайной программы — уточняйте при бронировании. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Узнать о мероприятиях", "href": "/banket" }
  }
];
